import _ from 'lodash'

export const deserializeString = (val: any): string | undefined => {
    try {
        const parsedVal = JSON.parse(val)
        if (_.isString(parsedVal)) {
            return parsedVal
        }
    } catch {
        return val
    }
}
